import {useCommonItems} from "../../../../contexts/CommonItensProvider";
import {useAppContext} from "../../../../contexts/AppContext";
import {Helmet} from "react-helmet-async";
import {
    Autocomplete,
    Avatar,
    Box,
    Breadcrumbs,
    Button, CircularProgress,
    Grid, InputAdornment,
    Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField,
    Typography
} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import {Home as HomeIcon} from "@mui/icons-material";
import PageTitle from "../../../common/PageTitle";
import {
    BasketIcon,
    BusinessIcon,
    ClipboardIcon,
    GoalIcon,
    MechanicIcon,
    SystemInformationIcon,
    ToolsIcon
} from "../../../common/Icons";
import React, {useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {SelectEmpresaFilter} from "../../../common/SelectEmpresaFilter";
import {listaEmpresas} from "../../management/companies/configs/functions";
import {useQuery} from "@tanstack/react-query";
import {getRetiradasStatics} from "../products/configs/functions";
import {LoadingTableRow} from "../../../common/LoadingTableRow";
import {EmptyTableRow} from "../../../common/EmptyTableRow";
import {NewRequisicaoDialog} from "./components/NewRequisicaoDialog";
import {checkPermissionsAndRedirect} from "../../../../configs/functions";
import {useModuleContext} from "../../../../contexts/ModuleProvider";
import {
    finalizarSessao,
    iniciarSessao,
    listaUsuariosFilter,
    validarSessao
} from "../../management/people/configs/functions";
import {RetiradasManagementTableFilter} from "./components/RetiradasManagementTableFilter";
import {FiltersButton} from "../../../common/FiltersButton";
import {useSearchParams} from "react-router-dom";
import {logDOM} from "@testing-library/react";
import ListOfGHEs from "../guidelines/ListOfGHEs";
import {atualizaEquipamento, carregaEquipamentos} from "../equipments/configs/functions";

export function RetiradaRow({ data }) {
    return (
        <TableRow>
            <TableCell sx={{ flex: 2, borderBottom: 1, borderColor: '#EFEFEF' }}>
                {`${data.pessoa.matricula ? data.pessoa.matricula + ' - ' : ''}${data.pessoa.nome}`}
            </TableCell>
            <TableCell sx={{ flex: 2, borderBottom: 1, borderColor: '#EFEFEF' }}>
                {`${data.produto.cod_externo ? '[' + data.produto.cod_externo + '] - ' : ''}${data.produto.nome}`}
            </TableCell>
            <TableCell sx={{ flex: 2, borderBottom: 1, borderColor: '#EFEFEF' }}>{data.quantidade}</TableCell>
            <TableCell sx={{ flex: 2, borderBottom: 1, borderColor: '#EFEFEF' }}>{data.tipo}</TableCell>
            <TableCell sx={{ flex: 2, borderBottom: 1, borderColor: '#EFEFEF' }}>{data.data_retirada}</TableCell>
        </TableRow>
    )
}

export function RetiradasManagement() {
    const { dadosUsuario, token } = useAppContext();
    const { getModuloSessionData, setModuloSessionData, markSessionAsExpired } = useAppContext();
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();
    const { getEmpresasPermissionsByModule } = useModuleContext();

    const { getEmpresaIdSession, setEmpresaIdSession } = useAppContext();

    const [searchParams, setSearchParams] = useSearchParams();

    const [empresas, setEmpresas] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);
    const [empresaAnterior, setEmpresaAnterior] = useState(null);

    const [pessoas, setPessoas] = useState([]);
    const [equipamentos, setEquipamentos] = useState([]);

    const [lastRetiradas, setLastRetiradas] = useState([]);
    const [requisicoesHoje, setRequisicoesHoje] = useState(0);
    const [variacaoPercentual, setVariacaoPercentual] = useState(0);
    const [retiradasPendentes, setRetiradasPendentes] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const [requisicaoOpen, setRequisicaoOpenn] = useState(false);
    const [tipoRequisicao, setTipoRequisicao] = useState(null);

    const [isOpenFilters, setIsOpenFilters] = useState(false);
    const [activeFilters, setActiveFilters] = useState(0);

    const [idSessao, setIdSessao] = useState(null);
    const [sessaoFinalizada, setSessaoFinalizada] = useState(false);
    const [disabledPage, setDisabledPage] = useState(false);

    const [mainMessage, setMainMessage] = useState(null);

    const idSessaoRef = useRef(null);
    const sessaoFinalizadaRef = useRef(false);
    const empresaAtualRef = useRef(null);
    const lastInteractionRef = useRef(new Date());
    const encerrandoRef = useRef(false);
    const reabrindoRef = useRef(false);

    // Sincroniza as refs com o state
    useEffect(() => { idSessaoRef.current = idSessao; }, [idSessao]);
    useEffect(() => { sessaoFinalizadaRef.current = sessaoFinalizada; }, [sessaoFinalizada]);
    useEffect(() => { empresaAtualRef.current = selectedEmpresaId; }, [selectedEmpresaId]);

    const {
        setValue,
        reset,
        formState: { errors },
    } = useForm();

    const { data: empresasData, error: listaEmpresasError, isLoading: isLoadingEmpresasData, isPending } = useQuery({
        queryKey: ['listaEmpresas'],
        queryFn: async () => {
            const response = await listaEmpresas(null, null, null, true);
            const todasEmpresas = response?.data.data || [];

            const empresasComPermissao = getEmpresasPermissionsByModule('Balcao', todasEmpresas);
            const empresasComContrato = empresasComPermissao.filter(empresa => empresa.idContrato != null);

            let defaultEmpresaId = null;
            const selectedEmpresaIdSession = getEmpresaIdSession();

            if (selectedEmpresaIdSession) {
                defaultEmpresaId = selectedEmpresaIdSession;
            } else if (empresasComContrato.length > 0) {
                defaultEmpresaId = empresasComContrato[0].id;
                setEmpresaIdSession(empresasComContrato[0].id);
            }

            setSelectedEmpresaId(defaultEmpresaId);
            setSelectedEmpresa(empresasComContrato[0]);

            const defaultValues = {
                id_empresas: defaultEmpresaId
            };
            reset(defaultValues);

            // Retorna apenas as empresas com permissão
            return empresasComContrato;
        },
        refetchOnWindowFocus: false,
    });

    async function retiradasStatisticsData() {
        try {
            setIsLoading(true);

            const res = await getRetiradasStatics({
                id_empresa: selectedEmpresaId,
                matricula: searchParams.get('matricula'),
                cod_externo: searchParams.get('cod_externo'),
                tipo: searchParams.get('tipo')
            });
            setLastRetiradas(res.data.ultimas_retiradas);
            setVariacaoPercentual(res.data.variacao_percentual);
            setRetiradasPendentes(res.data.qtd_retiradas_pendentes);
            setRequisicoesHoje(res.data.requisicoes_hoje);
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar as estatísticas', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    async function getColaboradores() {
        try {
            setIsLoading(true);

            const res = await listaUsuariosFilter({ id_empresas: [selectedEmpresaId], isFilter: true, isCompressed: true });
            setPessoas(res.data.data);
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar os colaboradores', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    async function getEquipamentos() {
        try {
            setIsLoading(true);

            const res = await carregaEquipamentos({ id_empresas: [selectedEmpresaId], tipo: 'virtual', isFilter: true });
            setEquipamentos(res.data.data);
        } catch (error) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar os equipamentos', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    async function verificarAcesso(empresaId) {
        try {
            const id_sessao = getModuloSessionData()?.idSessao;
            if (id_sessao) setIdSessao(id_sessao);
            const res = await validarSessao({
                id_empresa: empresaId,
                id_sessao: id_sessao || idSessaoRef.current,
                isFilter: true
            });
            return res.data.result;
        } catch (err) {
            exibirAlerta('Ops', 'Erro ao verificar sessão', 'error');
            return false;
        }
    }

    function registrarInteracao() {
        lastInteractionRef.current = new Date();
    }

    async function encerrarSessao(status = "finalizado") {
        const idSessaoAtual = idSessaoRef.current;
        const idEmpresa = empresaAtualRef.current;

        if (encerrandoRef.current) return;
        if (sessaoFinalizadaRef.current || !idSessaoAtual) return;

        encerrandoRef.current = true;

        // Marca ANTES de aguardar, para bloquear chamadas concorrentes
        sessaoFinalizadaRef.current = true;
        setSessaoFinalizada(true);
        markSessionAsExpired();

        try {
            await finalizarSessao({
                id_empresa: idEmpresa,
                id_sessao: idSessaoAtual,
                status,
                isFilter: true,
            });
        } catch (error) {
            // silencioso
        } finally {
            encerrandoRef.current = false;
        }
    }

    async function reabrirSessao() {
        const idEmpresa = empresaAtualRef.current;

        if (reabrindoRef.current) return;
        if (!idEmpresa) return;

        // Só reabre se a sessão foi de fato encerrada
        const sessaoExistente = getModuloSessionData();
        if (sessaoExistente && !sessaoExistente.expired) {
            // Ainda existe sessão válida, nada a fazer
            idSessaoRef.current = sessaoExistente.idSessao;
            setIdSessao(sessaoExistente.idSessao);
            return;
        }

        reabrindoRef.current = true;

        try {
            const allowInteraction = await verificarAcesso(idEmpresa);
            if (!allowInteraction) {
                setMainMessage("Número limite de sessões alcançado");
                setDisabledPage(true);
                setTimeout(() => { window.location.href = "/"; }, 5000);
                return;
            }

            const novaSessao = await iniciarSessao({
                id_empresa: idEmpresa,
                tipo_dispositivo: "Balcao Web",
                token: token,
                isFilter: true
            });

            if (novaSessao?.data?.data) {
                setModuloSessionData(novaSessao.data.data, idEmpresa, 2);
                idSessaoRef.current = novaSessao.data.data;
                setIdSessao(novaSessao.data.data);
                setEmpresaAnterior(idEmpresa);

                // Reativa a página e libera nova finalização
                sessaoFinalizadaRef.current = false;
                setSessaoFinalizada(false);
                setDisabledPage(false);
                setMainMessage(null);
                lastInteractionRef.current = new Date();
            }
        } catch (error) {
            exibirAlerta('Ops', 'Erro ao reabrir a sessão', 'error');
        } finally {
            reabrindoRef.current = false;
        }
    }

    useEffect(() => {
        if (empresasData) setEmpresas(empresasData);
    }, [empresasData]);

    useEffect(() => {
        if (!empresas || empresas.length <= 0 || !Array.isArray(empresas)) return;
        if (!selectedEmpresaId) return;

        const empresaAtualTemModulo = empresas.some(e => e.id === selectedEmpresaId);
        if (!empresaAtualTemModulo) {
            // Escolhe a primeira empresa com permissão
            const empresaComModulo = empresas[0];
            if (empresaComModulo) {
                setSelectedEmpresaId(empresaComModulo.id);
                setSelectedEmpresa(empresaComModulo);
                setEmpresaIdSession(empresaComModulo.id);
                exibirAlerta('Atenção', `A empresa selecionada não possui acesso a este módulo. Alternamos automaticamente para "${empresaComModulo.nomeFantasia}".`, 'warning');
            }
        }
    }, [empresas, selectedEmpresaId]);

    useEffect(() => {
        if (selectedEmpresaId) {
            getColaboradores();
            getEquipamentos();
        }
    }, [selectedEmpresaId]);

    useEffect(() => {
        const idEmpresa = searchParams.get('id_empresa');
        if (idEmpresa) setSelectedEmpresaId(parseInt(idEmpresa));
    }, [searchParams]);

    useEffect(() => {
        if (selectedEmpresaId) {
            setSessaoFinalizada(true);
            retiradasStatisticsData();
        }
    }, [selectedEmpresaId]);

    useEffect(() => {
        const requiredPermissionsView = ["admin", "admin_retiradas"];
        checkPermissionsAndRedirect(requiredPermissionsView);
    }, []);

    useEffect(() => {
        let idSessaoAtual = null;

        async function checarSessao() {
            if (!selectedEmpresaId) return;

            const allowInteraction = await verificarAcesso(selectedEmpresaId);

            if (!allowInteraction) {
                setMainMessage("Número limite de sessões alcançado");
                setDisabledPage(true);

                setTimeout(() => {
                    window.location.href = "/";
                }, 5000);
                return;
            }

            let sessaoExistente = getModuloSessionData();

            // Caso tenha mudado de empresa, finaliza a anterior
            if (empresaAnterior && empresaAnterior !== selectedEmpresaId) {
                if (idSessaoAtual || idSessaoRef.current) {
                    await finalizarSessao({
                        id_empresa: empresaAnterior,
                        id_sessao: idSessaoAtual || idSessaoRef.current,
                        status: "finalizado",
                        isFilter: true
                    });
                }
                markSessionAsExpired();
                setEmpresaAnterior(selectedEmpresaId);
            }

            sessaoExistente = getModuloSessionData();

            if (!sessaoExistente || sessaoExistente.expired) {
                const agora = new Date();
                const diff = (agora - lastInteractionRef.current) / 1000;

                if (diff < 60) {
                    const novaSessao = await iniciarSessao({
                        id_empresa: selectedEmpresaId,
                        tipo_dispositivo: "Balcao Web",
                        token: token,
                        isFilter: true
                    });

                    if (novaSessao?.data?.data) {
                        setModuloSessionData(novaSessao.data.data, selectedEmpresaId, 2);
                        idSessaoAtual = novaSessao.data.data;
                        idSessaoRef.current = idSessaoAtual;
                        setIdSessao(idSessaoAtual);
                        setEmpresaAnterior(selectedEmpresaId);
                        // sessão ativa novamente
                        sessaoFinalizadaRef.current = false;
                        setSessaoFinalizada(false);
                    }
                } else {
                    // Sessão expirada por inatividade
                    setMainMessage("Sessão expirada por inatividade");
                    setDisabledPage(true);
                    markSessionAsExpired();

                    if (idSessaoAtual || idSessaoRef.current) {
                        await finalizarSessao({
                            id_empresa: selectedEmpresaId,
                            id_sessao: idSessaoAtual || idSessaoRef.current,
                            status: "expirado",
                            isFilter: true
                        });
                    }
                    sessaoFinalizadaRef.current = true;
                    setSessaoFinalizada(true);

                    setTimeout(() => {
                        window.location.href = "/";
                    }, 5000);
                }
            } else {
                idSessaoAtual = sessaoExistente.idSessao;
                idSessaoRef.current = idSessaoAtual;
                setIdSessao(idSessaoAtual);
                setEmpresaAnterior(selectedEmpresaId); // mantém atualizado
            }
        }

        checarSessao();
        const interval = setInterval(checarSessao, 30000);

        return () => {
            clearInterval(interval);
        };
    }, [selectedEmpresaId]);

    useEffect(() => {
        // Rastreia interação do usuário
        window.addEventListener("keydown", registrarInteracao);
        window.addEventListener("click", registrarInteracao);

        // Fechar aba / recarregar / navegar para outra URL
        const handlePageHide = () => {
            encerrarSessao("finalizado");
        };

        // Trocar de aba / minimizar (encerra) e voltar (reabre)
        const handleVisibilityChange = () => {
            if (document.hidden) {
                encerrarSessao("finalizado");
            } else {
                reabrirSessao();
            }
        };

        window.addEventListener("beforeunload", handlePageHide);
        window.addEventListener("pagehide", handlePageHide);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("keydown", registrarInteracao);
            window.removeEventListener("click", registrarInteracao);
            window.removeEventListener("beforeunload", handlePageHide);
            window.removeEventListener("pagehide", handlePageHide);
            document.removeEventListener("visibilitychange", handleVisibilityChange);

            // Desmontagem do componente (troca de rota dentro do SPA)
            encerrarSessao("finalizado");
        };
    }, []);

    return (
        <>
            <Helmet title="Registro de retiradas e requisições" defer={false} />

            {/* Overlay para desabilitar a página */}
            {disabledPage && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        backdropFilter: 'blur(2px)',
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        pointerEvents: 'all', // Bloqueia todos os cliques
                    }}
                >
                    <Paper
                        elevation={4}
                        sx={{
                            p: 3,
                            borderRadius: 2,
                            textAlign: 'center',
                            maxWidth: 400,
                            mx: 2
                        }}
                    >
                        <CircularProgress size={40} sx={{ mb: 2 }} />
                        <Typography variant="h6" gutterBottom>
                            {mainMessage}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Estamos te redirecionando para tela principal. Tente novamente mais tarde...
                        </Typography>
                    </Paper>
                </Box>
            )}

            {/* Conteúdo principal com opacidade reduzida quando desabilitado */}
            <Box
                sx={{
                    opacity: disabledPage ? 0.4 : 1,
                    pointerEvents: disabledPage ? 'none' : 'auto',
                    transition: 'opacity 0.3s ease-in-out',
                }}
            >
                {isLoadingEmpresasData ? (
                    <Box
                        sx={{
                            height: '100vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {(!empresas || empresas.length !== 0) ? (
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="stretch"
                                spacing={3}
                            >
                                <Grid item xs={12}>
                                    <Breadcrumbs>
                                        <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                                        <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao>
                                        <LinkNavegacao to='/epis/retiradas'>Retiradas</LinkNavegacao>
                                        <Typography variant='span'>Registro de retiradas e requisições</Typography>
                                    </Breadcrumbs>
                                    <PageTitle icon={<SystemInformationIcon fontSize='large' />} title="Registro de retiradas e requisições" />
                                    <Typography mt={1}>Este módulo permite o controle completo das retiradas e requisições de Equipamentos de Proteção Individual (EPI's) pelos colaboradores da empresa. Ele garante rastreabilidade, segurança e organização na entrega de itens obrigatórios de proteção.</Typography>
                                </Grid>

                                <Grid
                                    container
                                    item
                                    xs={12}
                                    spacing={3}
                                    alignItems="center"
                                >
                                    <Grid container item xs={12} spacing={2} justifyContent="flex-start">
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            display='flex'
                                            justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end' }}
                                            order={{ xs: 1, sm: 1, md: 2 }}
                                            sx={{ marginBottom: { xs: 2, sm: 2, md: 0 } }}
                                        >
                                            <Box
                                                display="flex"
                                                flexDirection={{ xs: 'column', sm: 'row' }}
                                                gap={{ xs: 1, sm: 2 }}
                                                width={{ xs: '100%', sm: 'auto' }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    startIcon={<MechanicIcon style={{ fontSize: 32 }} />}
                                                    sx={{
                                                        padding: '12px 5px',
                                                        fontSize: '1rem',
                                                        width: { xs: '100%', sm: '200px' }
                                                    }}
                                                    onClick={() => {
                                                        setRequisicaoOpenn(true);
                                                        setTipoRequisicao("retirada");
                                                    }}
                                                    disabled={isLoading || disabledPage}
                                                >
                                                    Nova retirada
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<ToolsIcon style={{ fontSize: 32 }} />}
                                                    sx={{
                                                        padding: '12px 5px',
                                                        fontSize: '1rem',
                                                        width: { xs: '100%', sm: '200px' }
                                                    }}
                                                    onClick={() => {
                                                        setRequisicaoOpenn(true);
                                                        setTipoRequisicao("extra");
                                                    }}
                                                    disabled={isLoading || disabledPage}
                                                >
                                                    Nova requisição
                                                </Button>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={8}
                                            order={{ xs: 2, sm: 2, md: 1 }}
                                        >
                                            <FiltersButton
                                                isOpenFilters={isOpenFilters}
                                                setIsOpenFilters={setIsOpenFilters}
                                                activeFilters={activeFilters}
                                                disabled={disabledPage}
                                            />
                                        </Grid>

                                        <RetiradasManagementTableFilter
                                            isOpenFilters={isOpenFilters}
                                            isLoadingList={isLoading}
                                            empresas={empresas}
                                            disabled={disabledPage}
                                            selectedIdEmpresa={selectedEmpresaId}
                                            setEmpresaAnterior={setEmpresaAnterior}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} mt={4} ml={1}>
                                    <Grid item xs={9}>
                                        <Typography variant="h6" fontWeight="bold">
                                            Últimos registros
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography variant="h6" fontWeight="bold">
                                            Estatísticas
                                        </Typography>
                                    </Grid>

                                    {/* Conteúdo principal */}
                                    <Grid item xs={9}>
                                        <TableContainer component={Paper} sx={{ height: 500 }}>
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Funcionário</TableCell>
                                                        <TableCell>Produto</TableCell>
                                                        <TableCell>Quantidade</TableCell>
                                                        <TableCell>Registro</TableCell>
                                                        <TableCell>Data</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {isLoading ? <LoadingTableRow />
                                                        : lastRetiradas && lastRetiradas?.length > 0
                                                            ? lastRetiradas.map((retirada) =>
                                                                <RetiradaRow
                                                                    key={retirada.id}
                                                                    data={retirada}
                                                                    disabled={disabledPage}
                                                                />
                                                            )
                                                            : <EmptyTableRow />
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Grid container direction="column" spacing={3}>
                                            {/* CARD 1 */}
                                            <Grid item>
                                                <Paper sx={{ height: 150, borderRadius: 2, p: 2, overflow: 'visible' }}>
                                                    <Box
                                                        display="flex"
                                                        flexDirection="row"
                                                        alignItems="center"
                                                        height="100%"
                                                        gap={2}
                                                    >
                                                        <BasketIcon sx={{ fontSize: 40 }} color="primary" />

                                                        <Box>
                                                            <Typography variant="h4" fontWeight="bold">
                                                                {requisicoesHoje !== 0 ? requisicoesHoje : '-'}
                                                            </Typography>
                                                            <Typography variant="body1" color="text.secondary">
                                                                Registros realizados hoje
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            </Grid>

                                            {/* CARD 2 */}
                                            <Grid item>
                                                <Paper sx={{ height: 150, borderRadius: 2, p: 2 }}>
                                                    <Box
                                                        display="flex"
                                                        flexDirection="row"
                                                        alignItems="center"
                                                        height="100%"
                                                        gap={2}
                                                    >
                                                        <GoalIcon sx={{ fontSize: 40 }} color="primary" />
                                                        <Box>
                                                            <Typography variant="h4" fontWeight="bold">
                                                                {variacaoPercentual > 0 ? '+' : ''}
                                                                {variacaoPercentual !== 0 ? variacaoPercentual + '%' : '-'}
                                                            </Typography>
                                                            <Typography variant="body1" color="text.secondary">
                                                                Variação mensal
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            </Grid>

                                            {/* CARD 3 */}
                                            <Grid item>
                                                <Paper sx={{ height: 150, borderRadius: 2, p: 2 }}>
                                                    <Box
                                                        display="flex"
                                                        flexDirection="row"
                                                        alignItems="center"
                                                        height="100%"
                                                        gap={2}
                                                    >
                                                        <BusinessIcon sx={{ fontSize: 40 }} color="primary" />
                                                        <Box>
                                                            <Typography variant="h4" fontWeight="bold">
                                                                {retiradasPendentes !== 0 ? retiradasPendentes : '-'}
                                                            </Typography>
                                                            <Typography variant="body1" color="text.secondary">
                                                                Retiradas pendentes
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
                                <Typography variant="h5" color="text.secondary">
                                    Módulo indisponível
                                </Typography>
                            </Grid>
                        )}
                    </>
                )}
            </Box>

            <NewRequisicaoDialog
                open={requisicaoOpen && !disabledPage}
                onClose={() => setRequisicaoOpenn(false)}
                selectedIdEmpresa={selectedEmpresaId}
                selectedEmpresa={selectedEmpresa}
                tipoRequisicao={tipoRequisicao}
                pessoas={pessoas}
                equipamentos={equipamentos}
            />
        </>
    )
}